import { render, staticRenderFns } from "./BackgroundItemOverall.vue?vue&type=template&id=7a167405&scoped=true"
import script from "./BackgroundItemOverall.vue?vue&type=script&lang=js"
export * from "./BackgroundItemOverall.vue?vue&type=script&lang=js"
import style0 from "./BackgroundItemOverall.vue?vue&type=style&index=0&id=7a167405&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a167405",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a167405')) {
      api.createRecord('7a167405', component.options)
    } else {
      api.reload('7a167405', component.options)
    }
    module.hot.accept("./BackgroundItemOverall.vue?vue&type=template&id=7a167405&scoped=true", function () {
      api.rerender('7a167405', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/background/BackgroundItemOverall.vue"
export default component.exports